import {Injectable} from '@angular/core';
import {ConsumerService} from '../../shared/services/consumer.service';
import {WebServices} from '../../shared/models/enum/web-services.enum';
import {Observable} from 'rxjs';
import {Response} from '../../shared/models/response';
import {AccountBank} from '../../shared/models/accountBank';
import { environment } from 'src/environments/environment';

@Injectable({providedIn: 'root'})
export class ObsicashAssociateAccountService {

  constructor(private consumerService: ConsumerService) { }

  getAssociateAccount(): Observable<Response> {
    return this.consumerService.get(environment.jweUrls.URL_GET_OBSICASH_ASSOCIATE_ACCOUNT.url );
  }

  deleteAssociateAccount(account: AccountBank): Observable<Response> {
    return this.consumerService.delete(environment.jweUrls.URL_DELETE_OBSICASH_ASSOCIATE_ACCOUNT.url , account.code);
  }
  createAssociateAccount(req): Observable<Response> {
    return this.consumerService.put(environment.jweUrls.URL_POST_OBSICASH_CREATE_ASSOCIATE_ACCOUNT.url , req);
  }
}
